<template>
    <LayoutSidebar v-model:isOpen="isSidebarOpen">
        <template #sidebar>
            <cSidebar />
        </template>
        <template #logo>
            <EasyToolsIcon />
        </template>
        <template #header>
            <div class="flex items-center justify-between">
                <p class="text-2xl font-medium ct-text-1">{{ title }}</p>
                <CStagingMarker />
                <CImpSession />
                <div class="fixed lg:hidden bottom-3 right-3 z-10">
                    <ButtonPrimaryIconMd @click="create">
                        <AddIcon />
                    </ButtonPrimaryIconMd>
                </div>
                <div class="relative hidden lg:block">
                    <ButtonPrimaryMd @click="create">
                        <AddIcon /> <span>{{ empty.ctaLabel }}</span>
                    </ButtonPrimaryMd>
                </div>
            </div>
        </template>
        <template #main>
            <c-access-banner />
            <cProjectsList>
                <cProjectRow
                    v-for="project in projects"
                    :key="project.uuid"
                    :project="project"
                    :icon="icon"
                    :badgeText="badgeText ? badgeText(project) : ''"
                />
            </cProjectsList>
            <cProjectEmpty
                v-if="!projects.length"
                :title="empty.title"
                :subtitle="empty.subtitle"
                :icon="icon"
                :cta-label="empty.ctaLabel"
                @add="create"
            />
        </template>
    </LayoutSidebar>
</template>

<script>
import { projectsService } from "@/shared/projects/projects.service";
import { mapGetters, mapMutations } from "vuex";
import { LayoutSidebar } from "@easy/ui/layouts";
import { ButtonPrimaryIconMd, ButtonPrimaryMd } from "@easy/ui/buttons";
import { AddIcon, EasyToolsIcon } from "@easy/ui/icons";
import cAccessBanner from "../components/cAccessBanner.vue";
import cSidebar from "../components/cSidebar.vue";
import CImpSession from "@/shared/components/cImpSession.vue";
import cProjectsList from "@/shared/components/cProjectsList.vue";
import cProjectRow from "@/shared/components/cProjectRow.vue";
import cProjectEmpty from "@/shared/components/cProjectEmpty.vue";
import CStagingMarker from "@/shared/components/cStagingMarker.vue";

export default {
    components: {
        CStagingMarker,
        LayoutSidebar,
        ButtonPrimaryIconMd,
        ButtonPrimaryMd,
        AddIcon,
        EasyToolsIcon,
        cAccessBanner,
        cSidebar,
        CImpSession,
        cProjectsList,
        cProjectRow,
        cProjectEmpty,
    },
    name: "vProjects",
    props: {
        title: String,
        tool: String,
        icon: Object,
        empty: Object,
        badgeText: Function,
    },
    data() {
        return {
            isSidebarOpen: false,
            projects: [],
        };
    },
    computed: {
        ...mapGetters(["userId"]),
    },
    watch: {
        userId: {
            immediate: true,
            handler(newValue) {
                if (newValue) {
                    this.loadProjects();
                }
            },
        },
    },
    methods: {
        ...mapMutations(["showModal"]),
        create() {
            const modalData = {
                type: "input",
                input: "",
                title: this.$t("shared.list.name_project"),
                cancelBtn: this.$t("shared.cancel"),
                actionBtn: this.$t("shared.add"),
                callback: () => {
                    this.createProject(modalData.input);
                },
            };
            this.showModal(modalData);
        },
        async createProject(name) {
            const project = await projectsService.create({ tool: this.tool, name });
            window.location.href = project.url;
        },
        async loadProjects() {
            this.projects = await projectsService.getAllForUser({ tool: this.tool });
        },
    },
};
</script>
